import cookie from 'cookie';
import { RequestOptions } from '../types';
import isBrowser from '../../is-browser';
import { uriParse } from '../utils';

function requsetSdkQuery(options: RequestOptions) {
  const { url, headers } = options;

  const urlObj = uriParse(url);

  // Next 项目去掉自动加u行为
  if (/^\/n\//.test(urlObj.pathname)) {
    return options;
  }

  if (/^\/sdk\//.test(urlObj.pathname)) {
    const cookies = cookie.parse((isBrowser ? document.cookie : headers.cookie) || '');
    // 此处会对于 /sdk 相关的请求增加 u 的参数设置，
    // 如果需要使用 window.location.search 中的 u，请通过 query 传入
    if (!options.params?.u && cookies.u) {
      const prefix = options.url.includes('?') ? '&' : '?';
      // eslint-disable-next-line no-param-reassign
      options.url = `${options.url + prefix}u=${cookies.u}`;
    }
  }
  return options;
}

export default requsetSdkQuery;
